import { Component, ChangeDetectionStrategy, EventEmitter, Output, Input } from '@angular/core';
import { ViewMode } from '@src/models';
import { Nullable } from '@src/types/utils';

import { ContactsCustomListItem } from '../../types';

@Component({
  selector: 'list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListComponent {
  @Input() listItems?: Nullable<Array<ContactsCustomListItem>>;
  @Input() isParent = false;
  @Input() directoryTitle?: string;
  @Input() maxTitleLength: number = 100;

  @Output() save = new EventEmitter<Array<ContactsCustomListItem>>();
  @Output() return = new EventEmitter<void>();
  @Output() selectDirectory = new EventEmitter<ContactsCustomListItem>();
  @Output() removeItem = new EventEmitter<string>();

  mode: ViewMode = 'view';

  onSave(listItems: Array<ContactsCustomListItem>) {
    this.save.emit(listItems);
    this.mode = 'view';
  }

  onEdit() {
    this.mode = 'edit';
  }

  onCancelEdit() {
    this.mode = 'view';
  }
}
